__turbopack_context__.v({
  "compact": "maps-page-module__wLNX5q__compact",
  "grid": "maps-page-module__wLNX5q__grid",
  "page": "maps-page-module__wLNX5q__page",
  "preview": "maps-page-module__wLNX5q__preview",
  "previewImage": "maps-page-module__wLNX5q__previewImage",
  "title": "maps-page-module__wLNX5q__title",
});
